import * as React from "react";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
import {
  CourseType,
  PaymentsType,
  RepresentativeType,
  StudentFormType,
} from "../../types/entitiesModel";
import PaymentStudentdataPrivate from "./../Students/PaymentStudentDataPrivate";
import { useNavigate, useParams } from "react-router-dom";


const StudentMonthlyPayment: React.FC = () => {
  // Params from link
  const { studentId, representativeId, courseId } = useParams();

  // To navigation
  const navigate = useNavigate();

  const [representative, setRepresentative] =
    React.useState<RepresentativeType | null>(null);

  const [selectionCourse, setSelectionCourse] =
    React.useState<CourseType | null>(null);

  const [selectionPaymentMethod, setSelectionPaymentMethod] =
    React.useState<PaymentsType | null>(null);

  const [formStateStudent, setFormStateStudent] =
    React.useState<StudentFormType>({
      name: "",
      document: "",
      email: "",
      phone: "",
      address: "",
      representative_id: 0,
      category_id: 0,
      imageString: ""
    });

  const [reference, setReference] = React.useState<string>("");

  const [loading, setLoading] = React.useState<boolean>(false);
  const [loadingSend, setLoadingSend] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    const fetchDataStuddent = async () => {
      setLoading(true);

      fetch(`appservice/students/${studentId}`)
        .then((response) => response.json())
        .then((data) => {
          setFormStateStudent({
            name: data.name,
            document: data.document,
            email: data.email,
            phone: data.phone,
            address: data.address,
            representative_id: data.representative_id,
            category_id: data.category_id,
            imageString: data.image // Arreglar esto en backend
          });

          setLoading(false);
        })
        .catch((error) => {
          setError(error);
          console.error(error);
          setLoading(false);
        });
    };

    const fetchRepresentativeData = async () => {
      setLoading(true);

      fetch(`appservice/representatives/${representativeId}`)
        .then((response) => response.json())
        .then((data) => {
          setRepresentative(data);
        })
        .catch((error) => {
          setError(error);
          console.error(error);
          setLoading(false);
        });
    };

    const fetchCoursedata = async () => {
      setLoading(true);

      fetch(`appservice/courses/${courseId}`)
        .then((response) => response.json())
        .then((data) => {
          setSelectionCourse(data);
          setLoading(false);
        })
        .catch((error) => {
          setError(error);
          console.error(error);
          setLoading(false);
        });
    };

    fetchDataStuddent();
    fetchRepresentativeData();
    fetchCoursedata();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentId, representativeId, courseId]);

  /**
   * to send data to api
   */
  const handleSubmit = async () => {
    setLoadingSend(true);
    setError(null);

    if (
      !formStateStudent.name ||
      !selectionCourse ||
      !selectionPaymentMethod ||
      !reference
    ) {
      setError(
        "Por favor, complete todos los campos y asegúrese de que las contraseñas coincidan."
      );
      return;
    }

    const data = {
      student: formStateStudent,
      representative: representative,
      course: selectionCourse,
      paymentMethod: selectionPaymentMethod,
      reference,
    };

    try {
      const response = await fetch("appservice/coursestudentsprivate", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || "Hubo un problema al enviar el formulario."
        );
      }

      alert("Inscripción completada con éxito");

      setTimeout(() => {
        navigate("/success");
      }, 1000);
    } catch (err: any) {
      setError(err.message || "Ocurrió un error en el servidor.");
    } finally {
      setLoadingSend(false);
    }
  };

  return (
    <>
      {!loading ? (
        <Box>
          {error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {error}
            </Alert>
          )}
          <Typography variant="h1" sx={{ ml: 2, mb: 4 }}>
            Información de Pago
          </Typography>

          <PaymentStudentdataPrivate
            representativeData={representative}
            courseData={selectionCourse}
            selectionPaymentMethod={selectionPaymentMethod}
            setSelectionPaymentMethod={setSelectionPaymentMethod}
            studentData={formStateStudent}
            reference={reference}
            setReference={setReference}
            isMonthlyPay={true}
          />

          <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={loading}
              sx={{
                minWidth: "150px",
                position: "relative",
              }}
            >
              {loadingSend ? (
                <Box sx={{ padding: 2 }}>
                  {" "}
                  <CircularProgress
                    size={24}
                    sx={{
                      color: "white",
                    }}
                  />
                </Box>
              ) : (
                "Enviar Datos"
              )}
            </Button>
          </Box>
        </Box>
      ) : (
        <Box>
          <CircularProgress />
        </Box>
      )}
    </>
  );

};

export default StudentMonthlyPayment;
